export default __webpack_public_path__ + "static/media/Stonks_2.fcf6e5b4.PNG";